





















































































import {
    myVue
} from "@/components/class/myVue";
import {
    Component
} from 'vue-property-decorator';
@Component
export default class HelloWorld extends myVue {
    handleNodeClick(data: any) {
        this.current.tree_id = data.id;
        this.current.currentPage = 1;
        this.current.rows = 10;
        this.current.queryByPid();

    }
    myShowSummary(param: any) {
        return this.current.summaryData(param)
    }
    handleSizeChange(val: any) { // 更新查询的行数
        this.current.rows = val
        this.reQuery("content")
    }
    handleCurrentChange(val: any) { // 更新查询的页数
        this.current.currentPage = val
        this.reQuery("content")
    }
    sortChange(a: any, b: any, c: any) {}
    selectionChange(selection: any) {
        this.current.selectRow = selection
    }
    cellClick(a: any, b: any, c: any) {}
    cellMouseEnter(a: any, b: any, c: any) {}
    public_click(data: any) {
        this.current.selectRowOnly = data.row
        data.item.click({
            row: data.row
        })
    }
    public_click2(data: any) {
        data.item.click()
    }
}
